import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveLoader } from "../../redux/slice/loaderNoti";
import moment from "moment/moment";
import { useLazyReceptionistViewQuery } from "../../redux/api/api";

const ReceptionView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [btn, setBtn] = useState(false);

  const [details, setDetails] = useState({});

  // RTK QUERY
  const [receptionistViewApi] = useLazyReceptionistViewQuery();

  const receptionistView = () => {
    receptionistViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setDetails(res?.receptionist);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      receptionistView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"view-receptionist"} />
      <div className="p-3">
        <div className=" block block-rounded ">
          <div className="block-content">
            <div className="user-detail-table">
              <table className="tabledetails table-borderless user-det w-100 mb-5">
                <thead>
                  <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                    BASIC DETAILS
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Receptionist Id</td>
                    <td>:</td>
                    <td>{details?.receptionist_id}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Property Name</td>
                    <td>:</td>
                    <td>
                      {details?.property?.name} -{" "}
                      {details?.property?.property_id}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Property Owner</td>
                    <td>:</td>
                    <td>
                      {details?.owner?.name} - {details?.owner?.owner_id}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Receptionist Name</td>
                    <td>:</td>
                    <td>{details?.name}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>E-mail</td>
                    <td>:</td>
                    <td>{details?.email}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Mobile Number</td>
                    <td>:</td>
                    <td>{details?.mobile}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="p-3 ">
        <div className=" block block-rounded ">
          <div className="block-content">
            <div className="col-md-12 mb-3">
              <div className="head-dest d-flex ac-jb">Managing Properties</div>
            </div>
            <div className="row col-md-12 property-available p-3">
              <div className="col-md-3 mt-3">
                <div className="property-img">
                  <img
                    src={details?.property?.image}
                    alt="property-image"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-9 mt-3">
                <div>
                  <h4 className="f2 fs-sm-20 fs-md-22 fs-lg-24 fs-xl-26 fs-xxl-28">
                    {details?.property?.name}
                  </h4>
                  <p>
                    <strong>Category : </strong>
                    {details?.property?.category?.name}
                  </p>
                  <p>
                    <strong>State : </strong> {details?.property?.state?.name}
                  </p>
                  <p>
                    <strong>City : </strong> {details?.property?.city?.name}
                  </p>
                  <p>
                    <strong>Location : </strong>{" "}
                    {details?.property?.location?.name}
                  </p>
                  <p>
                    <strong>Street : </strong> {details?.property?.street}
                  </p>
                  <p>
                    <strong>Apartment : </strong> {details?.property?.apartment}
                  </p>
                  <p>
                    <strong>Door No : </strong> {details?.property?.door_no}
                  </p>
                  <p>
                    <strong>Pin Code : </strong> {details?.property?.pin_code}
                  </p>
                  <p>
                    <strong>Landmark : </strong> {details?.property?.landmark}
                  </p>
                  <p>
                    <strong>Status : </strong>{" "}
                    {details?.property?.status == 1 ? "Active" : "Deactive"}
                  </p>

                  <p>
                    <strong>Property Owner Name : </strong>
                    <button
                      className="link-btn"
                      onClick={() => {
                        navigate("/property-owner-view", {
                          state: {
                            type: "edit",
                            data: details?.owner,
                          },
                        });
                      }}
                    >
                      {details?.owner?.name}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceptionView;
